<template>
    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <form class="modal-content" v-on:submit.prevent="submit">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">{{ title }}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="loading" class="block-content text-center">
                        <p class="h4 mb-4">Loading</p>
                    </div>
                    <div v-show="loading === false" class="block-content fs-sm">
                        <div class="mb-4">
                            <label class="form-label" for="f_description">Description</label>
                            <input type="text" class="form-control" :class="{'is-invalid': errors.description}" id="f_description" v-model="jobDescription">

                            <div v-if="errors.description" class="invalid-feedback">{{ errors.description.join(', ') }}</div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="f_status">Status</label>
                            <select class="form-select" :class="{'is-invalid': errors.status}" id="f_status" v-model="jobStatus" required>
                                <option v-for="status in statuses">
                                    {{ status }}
                                </option>
                            </select>

                            <div v-if="errors.status" class="invalid-feedback">{{ errors.status.join(', ') }}</div>
                        </div>

                        <div class="mb-4">
                            <label class="form-label" for="f_staff">Staff</label>
                            <select class="form-select" :class="{'is-invalid': errors.staffUuids}" id="f_staff" ref="staffPicker" required multiple>
                            </select>

                            <div v-if="errors.staffUuids" class="invalid-feedback">{{ errors.staffUuids.join(', ') }}</div>
                        </div>

                        <div class="mb-4 form-check form-switch" v-if="couldDuplicateTimeEntries">
                            <input class="form-check-input" type="checkbox" value="yes" id="f_duplicate_time_entries" v-model="duplicateTimeEntries" />
                            <label class="form-check-label" for="f_duplicate_time_entries">Duplicate time entries of {{ jobStaff[0].both_names }} to other staff?</label>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                        <button v-if="!loading" type="submit" class="btn btn-sm btn-success">{{ submitText }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        reload: {
            type: Boolean,
            default: false,
        },
        routes: Object,
        statuses: Array,
    },
    data () {
        return {
            couldDuplicateTimeEntries: false,
            duplicateTimeEntries: false,
            errors: [],
            jobDescription: '',
            jobStaff: [],
            jobStatus: '',
            loading: false,
            modal: null,
            staffPicker: null,
            route: null,
            submitText: 'Submit',
            title: '',
        };
    },
    mounted () {
        this.modal = new Modal(this.$el);

        Eventbus.on('add-classics-job', (vehicleUuid) => {
            this.title = 'Add Job';
            this.submitText = 'Create';
            this.route = (vehicleUuid) ? this.routes.add.replace('replace-me', vehicleUuid) : this.routes.add;
            this.jobDescription = '';
            this.jobStaff = [];
            this.jobStatus = '';
            this.couldDuplicateTimeEntries = false;
            this.duplicateTimeEntries = false;
            this.errors = [];
            this.jobStatus = this.statuses[0];
            this.modal.show();
            setTimeout(this.createPicker, 50);
        });

        Eventbus.on('edit-classics-job', (jobUuid) => {
            this.loading = true;
            this.couldDuplicateTimeEntries = false;
            this.duplicateTimeEntries = false;
            this.errors = [];
            this.route = this.routes.edit.replace('replace-me', jobUuid);
            axios.get(this.route)
                .then((response) => {
                    this.title = 'Edit Job ' + response.data.description;
                    this.submitText = 'Update';
                    this.jobDescription = response.data.description;
                    this.jobStaff = response.data.staff;
                    this.jobStatus = response.data.status;
                    this.loading = false;
                    this.modal.show();
                    setTimeout(this.createPicker, 50);
                });
        });

        Eventbus.on('convert-classics-timeentry', (timeEntryUuid) => {
            axios.put(this.routes.convertTimeEntryRoute.replace('replace-me', timeEntryUuid)).then(({ data }) => {
                Eventbus.emit('time-entries-table-refresh');
                Eventbus.emit('edit-classics-job', data.data.job.uuid);
                Swal.fire('The time entry has been converted, you are now free to edit the new job');
            }).catch((error) => {
                let message = 'System Error';
                if (error.response && error.response.message) {
                    message = error.response.message;
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not convert Time Entry',
                    text: message,
                });
            });
        });
    },
    methods: {
        createPicker () {
            // this needs to be recreated each open for some reason
            this.staffPicker = window.jQuery(this.$refs.staffPicker).select2({
                dropdownParent: this.$el,
                placeholder: 'Select Staff',
                ajax: {
                    cache: true,
                    data: function(params) {
                        return {
                            search: params.term,
                            page: params.page
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function(data) {
                        // why do we need to do this?
                        return {
                            results: data.data
                        };
                    },
                    url: this.routes.staffFilter,
                }
            });

            if (this.staffPicker.find('option').length) {
                this.staffPicker.find('option').remove();
            }

            for (let staff of this.jobStaff) {
                this.staffPicker.append(window.jQuery('<option selected>' + staff.both_names + '</option>').val(staff.uuid));
            }

            this.staffPicker.trigger('change');

            this.staffPicker.on('select2:select select2:unselect select2:clear', () => {
                this.couldDuplicateTimeEntries = false;

                let now = this.staffPicker.val();
                if (this.submitText == 'Update' && this.jobStaff.length == 1 && now.length > 1 && now.indexOf(this.jobStaff[0].uuid) !== -1) {
                    this.couldDuplicateTimeEntries = true;
                }
            });
        },
        submit () {
            this.loading = true;
            axios.post(this.route, {
                description: this.jobDescription,
                staffUuids: this.staffPicker.val(),
                status: this.jobStatus,
                duplicateTimeEntries: this.couldDuplicateTimeEntries && this.duplicateTimeEntries,
            }).then((response) => {
                if (response.data.success === true) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Submitted job',
                        timer: 1500,
                        timerProgressBar: true,
                        showConfirmButton: false,
                    });
                    this.modal.hide();
                    Eventbus.emit('jobs-table-refresh');
                    if (this.reload) {
                        location.reload();
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not submit job',
                        text: 'Unknown error',
                    });
                }
            }).catch((error) => {
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }

                if (status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Could not submit job',
                        text: 'System error: ' + status,
                    });
                }
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>
